<template>
  <div>
    <BaseButton success small class="w-full" @click="handleReview"> Review </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleReview() {
      this.$modal.show({
        component: 'ManageAssetReviewModal',
        props: {
          projectAssetId: this.projectAssetId,
        },
        on: {},
        hideEvent: 'closed',
      });
    },
  },
};
</script>
